module.exports = __webpack_public_path__ + "img/m_cer-title-one.99a90790.png";